import { render, staticRenderFns } from "./AmountTriggerAction.vue?vue&type=template&id=4b4d9a62&scoped=true"
import script from "./AmountTriggerAction.vue?vue&type=script&lang=js"
export * from "./AmountTriggerAction.vue?vue&type=script&lang=js"
import style0 from "./AmountTriggerAction.vue?vue&type=style&index=0&id=4b4d9a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4d9a62",
  null
  
)

export default component.exports